import { createContext, useContext, useState } from 'react';

const StateContext = createContext({
    token: null,
    setToken: () => { },
    user: null,
    setUser: () => {}
});

export const ContextProvider = ({ children }) => {

    const [token, _setToken] = useState(null);
    const [user, _setUser] = useState(null);

    const setToken = (token) => {
        _setToken(token)

        if (token) {
            // Logica para token nos arquivos de api.js apiForm.js recarregarem novamente
            if (localStorage.getItem("ACCESS_TOKEN") === null) {
                localStorage.setItem('ACCESS_TOKEN', token);
                //navigate('/dashboard')
                //window.location.reload()
                window.location = '/dashboard';
            } else {
                localStorage.setItem('ACCESS_TOKEN', token);
            }

        } else {
            localStorage.removeItem('ACCESS_TOKEN');
        }
    }

    const setUser = (user) => {
        _setUser({
            user,
            roles: user.roles.map((role) => role.name),
        });
    }

    const hasRole = (rolesAllowed) => {
        return user?.roles?.some((role) => rolesAllowed.includes(role));
    };

    useState(() => {
        var tokenLocal = localStorage.getItem('ACCESS_TOKEN')
        var expires = new Date(localStorage.getItem('EXPIRES_TOKEN'))
        var atual_date = new Date()
        
        if (tokenLocal && (atual_date <= expires)) {
            setToken(tokenLocal)
        } else {
            setToken(null)
        }

    }, [])

    return (
        <StateContext.Provider value={{
            token,
            setToken,
            user,
            setUser,
            hasRole
        }}>
            {children}
        </StateContext.Provider>
    )
};

export const useStateContext = () => useContext(StateContext);
